import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="18" height="18" rx="9" fill="#0054FF" />
    <path
      d="M2 8.90501H12.4127V10.0825H2C2.00188 10.759 2.2223 11.4833 2.47165 12.1058C3.64066 15.0241 6.65001 16.7749 9.75558 16.4646C13.1699 16.1235 15.9833 13.0924 15.9999 9.6513C16.0039 8.81292 15.8891 7.97342 15.6064 7.18026C14.8106 4.94725 12.9146 3.23124 10.6025 2.68403C7.31297 1.90547 3.85159 3.65968 2.52444 6.76566C2.24607 7.41713 2.00593 8.1902 2 8.90501Z"
      fill="white"
    />
  </svg>
)
